import type { SendNowFormState } from "./types";

/**
 * A theme only applies when the delivery attaches the rendered deck — the
 * Presentation artifact as a PPTX or PDF (rendered server-side by
 * action-engine). Story/memo attachments and image sets are browser
 * snapshots of the canvas, which themes don't style.
 */
export const isThemedDeck = ({
  artifact,
  format,
}: Pick<SendNowFormState, "artifact" | "format">): boolean =>
  artifact === "presentation" && (format === "presentation" || format === "pdf");

/** The theme to show and send: the user's pick, else the default theme. */
export const resolveDeliveryTheme = (
  theme: string | null,
  defaultThemeKey: string | undefined,
): string | undefined => theme ?? defaultThemeKey;
